import type { ComponentType } from 'react'
import { SiteLayout } from '../components/SiteLayout'

/**
 * Standalone legal documents (privacy policy, terms). The MDX body carries its
 * own leading H1 (the document title), so this template just frames it in the
 * reading measure and prose typography, no extra page heading.
 */
export function LegalPage({ Content }: { Content?: ComponentType }) {
  return (
    <SiteLayout>
      <article className="pt-28 pb-20 md:pt-32 md:pb-28">
        <div className="container-prose prose">
          {Content ? <Content /> : null}
        </div>
      </article>
    </SiteLayout>
  )
}
